/** Deploy 3 · P1 — vista previa de cascada (bottom sheet) al soltar sobre otra cita. */
import { ArrowRight, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { formatTime12 } from '@/utils/bookingFormat';
import { tr } from '@/contexts/LanguageContext';

export const AgendaCascadeSheet = ({ cascade, saving, onCancel, onConfirm }) => (
  <Sheet open={Boolean(cascade)} onOpenChange={(o) => { if (!o) onCancel(); }}>
    <SheetContent side="bottom" className="bg-card border-border rounded-t-2xl" data-testid="agenda-cascade-dialog">
      <SheetHeader className="text-left">
        <SheetTitle className="font-display text-lg text-foreground">{tr("Mover en cascada")}</SheetTitle>
        <p className="text-xs text-muted-foreground">{tr("El horario elegido choca con otras citas. Puedes desplazarlas automáticamente:")}</p>
      </SheetHeader>
      <div className="mt-3 space-y-2 max-h-60 overflow-y-auto">
        {(cascade?.plan?.moves || []).map((mv) => (
          <div
            key={mv.booking_id}
            className={`flex items-center gap-2 text-xs rounded-lg border p-2 ${mv.is_primary ? 'border-primary/60 bg-primary/5' : 'border-border'}`}
            data-testid={`cascade-move-${mv.booking_id}`}
          >
            <div className="flex-1 min-w-0">
              <p className="font-medium truncate text-foreground">{mv.client_name || tr("Cliente")} · {mv.service_name}</p>
              <p className="text-muted-foreground flex items-center gap-1 tabular-nums">
                {formatTime12(mv.from_start)}
                <ArrowRight className="w-3 h-3" />
                <span className="text-foreground font-semibold">{formatTime12(mv.to_start)}</span>
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 grid grid-cols-2 gap-2">
        <Button variant="outline" className="rounded-full" onClick={onCancel} data-testid="cascade-cancel">{tr("No, elegir otro horario")}</Button>
        <Button className="rounded-full" onClick={onConfirm} disabled={saving} data-testid="cascade-confirm">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : tr("Confirmar movimiento")}
        </Button>
      </div>
    </SheetContent>
  </Sheet>
);
